import { Page } from '../../../../components/Page'

export const PaymentFailure = () => <Page isLoading />
